import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BreadcrumbComponent } from '@features/layout/breadcrumb/breadcrumb.component';
import { NotificationComponent } from '@features/layout/notification/notification.component';
import { NotificationsComponent } from '@features/layout/notification/notifications.component';
import { LoginPanelModule } from '@features/login-panel/login-panel.module';
import { NavigationModule } from '@features/navigation/navigation.module';
import { SearchModule } from '@features/search/search.module';
import { WidgetModule } from '@features/widget/widget.module';
import { SharedModule } from '@shared/shared.module';

import { BackdropComponent } from './backdrop/backdrop.component';
import { FooterGroupComponent } from './footer/footer-group/footer-group.component';
import { FooterSocialGroupComponent } from './footer/footer-social-group/footer-social-group.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderBasketLinkComponent } from './header/header-basket-link/header-basket-link.component';
import { HeaderComponent } from './header/header.component';
import { ProgressComponent } from './progress/progress.component';
import { NotificationBarComponent } from './notification-bar/notification-bar.component';

@NgModule({
    imports: [CommonModule, RouterModule, NavigationModule, SharedModule, WidgetModule, SearchModule, LoginPanelModule, HeaderComponent,
        FooterComponent,
        FooterGroupComponent,
        FooterSocialGroupComponent,
        BackdropComponent,
        HeaderBasketLinkComponent,
        BreadcrumbComponent,
        NotificationComponent,
        NotificationsComponent,
        ProgressComponent,
        NotificationBarComponent],
    exports: [
        HeaderComponent,
        FooterComponent,
        BackdropComponent,
        BreadcrumbComponent,
        NotificationsComponent,
        NotificationBarComponent
    ]
})
export class LayoutModule {}
